import React, { useState, useEffect} from "react";
import { Row, Col, Card, Button, Tag, Modal, Collapse, Flex} from "antd";


let release_date = "07/07/2025";
const LOCAL_STORAGE_KEY = "whats_new_seen_date";

const whatsNewFeatures = [
  {
    image: "https://public-assets.instantdm.com/product-gifs/instantdm-followup-demo-0707-2025.png",
    title: "Follow up Automation",
    description: "If your followers are not responding or not opened link, you can now follow up with them automatically. Boost your engagement with our new follow-up automation feature.",
    buttonText: "Try Now",
    // buttonLink: "/flow",
    tag: { color: "blue", text: "🔌 Flow Editor" }
  },
  {
    image: "https://public-assets.instantdm.com/product-gifs/instantdm-delay-automation-0707-2025-2.png",
    title: "Delay time increased",
    description: "We have increased the delay time for flow automation to 24 hours, so you can now automate your flows with more flexibility.",
    buttonText: "Learn More",
    // buttonLink: "/docs/global-automation",
    tag: { color: "blue", text: "🔌 Flow Editor" }
  },
  {
    image: "https://public-assets.instantdm.com/product-gifs/instantdm-delete-automation-0707-2025-2.png",
    title: "Delete Flows",
    description: "The most requested feature is here! You can now delete your flows, so you can keep your flow list clean and organized.",
    buttonText: "Learn More",
    // buttonLink: "/docs/global-automation",
    tag: { color: "red", text: "🔥 Most Requested" }
  },
  // Add more features as needed
];

const EarnWithIDM = [
  {
    image: "https://public-assets.instantdm.com/product-gifs/idm-earn-with-idm.gif",
    title: "Earn With InstantDM",
    description: "Create videos about InstantDM and include your referral link to earn commissions when people sign up through you.",
    buttonText: "See Example videos",
    buttonLink: "/referral-dashboard",
    // buttonLink: "/flow",
    
  },
  {
    image: "https://public-assets.instantdm.com/product-gifs/idm-ref-create-link.svg",
    title: "Create your referral link",
    description: "Generate your unique referral link in just a click and start promoting InstantDM by videos, blogs, or social media.",
    buttonText: "Create referral Link",
    buttonLink: "/referral-dashboard",
    tag: { color: "purple", text: "Step 1" }
  },
  {
    image: "https://public-assets.instantdm.com/product-gifs/idm-create-video.gif",
    title: "Make video about InstantDM",
    description: "Create a short video explaining how InstantDM works and include your referral link.",
    buttonText: "See Example videos",
    buttonLink: "/referral-dashboard",
    tag: { color: "purple", text: "Step 2" }
  },
  {
    image: "https://public-assets.instantdm.com/product-gifs/idm-24hrs.svg",
    title: "Get your money in 24 hours",
    description: "Earn instant commissions when people sign up through your link. Payouts within 24 hours.",
    buttonText: "Create referral Link",
    buttonLink: "/referral-dashboard",
    tag: { color: "purple", text: "Step 3" }
  },
  // Add more features as needed
];


const WhatsNew = () => {
  const [previewImage, setPreviewImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [activeKey, setActiveKey] = useState([]);

    const whats_new_items =  [
      {
      key: '2',
      label: 'Earn With InstantDM 🔥',
   
      children:<Flex justify="center" wrap>
        {EarnWithIDM.map((feature, idx) => (

            <Card
              hoverable = {false}
              style={{
                width: "100%",
                maxWidth: 320,
                minHeight: 380,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",

              }}
              cover={
                feature.image && (
                  <img
                    alt={feature.title}
                    src={feature.image}
                    style={{
                      objectFit: "cover",
                      height: "auto",
                      maxHeight: 180,
                      width: "100%",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setPreviewImage(feature.image);
                      setPreviewOpen(true);
                    }}
                  />
                )
              }
            >
              <Card.Meta
                title={
                  <p>
                    {feature.title}{" "}
                    {feature.tag && (
                      <Tag color={feature.tag.color} style={{ marginLeft: 8 }}>
                        {feature.tag.text}
                      </Tag>
                    )}
                  </p>
                }
                description={<div style={{ marginBottom: 16 }}>{feature.description}</div>}
              />
              {feature.buttonLink && (
                <Button
                  color="default"
                  variant="solid"
                  block
                  style={{ marginTop: 16 }}
                  href={feature.buttonLink}
                >
                  {feature.buttonText}
                </Button>
              )}
            </Card>
          
        ))}
      </Flex>
    },
    {
      key: '1',
      label: 'Whats New 🔥',
   
      children:<Flex justify="center" wrap gap={10}> 
        {whatsNewFeatures.map((feature, idx) => (
         
            <Card
              hoverable = {false}
              style={{
                width: "100%",
                maxWidth: 320,
                minHeight: 380,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",

              }}
              cover={
                feature.image && (
                  <img
                    alt={feature.title}
                    src={feature.image}
                    style={{
                      objectFit: "cover",
                      height: "auto",
                      maxHeight: 180,
                      width: "100%",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setPreviewImage(feature.image);
                      setPreviewOpen(true);
                    }}
                  />
                )
              }
            >
              <Card.Meta
                title={
                  <p>
                    {feature.title}{" "}
                    {feature.tag && (
                      <Tag color={feature.tag.color} style={{ marginLeft: 8 }}>
                        {feature.tag.text}
                      </Tag>
                    )}
                  </p>
                }
                description={<div style={{ marginBottom: 16 }}>{feature.description}</div>}
              />
              {feature.buttonLink && (
                <Button
                  color="default"
                  variant="solid"
                  block
                  style={{ marginTop: 16 }}
                  href={feature.buttonLink}
                >
                  {feature.buttonText}
                </Button>
              )}
            </Card>

        ))}
      </Flex>
    }
]

  useEffect(() => {
    const seenDate = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (seenDate === release_date) {
      setActiveKey(['2']); // collapsed by default
    } else {
      setActiveKey(['2']); // expanded by default
    //   localStorage.setItem(LOCAL_STORAGE_KEY, release_date);

    }
  }, []);

  const handleCollapseChange = (keys) => {
    setActiveKey(keys);
    if (keys.includes('1')) {
      localStorage.setItem(LOCAL_STORAGE_KEY, release_date);
    }
  };
  return(
    <></>
  )

  return <></>

    return(
        <div style={{width:"100%", maxWidth:"500px"}}>
        <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
        centered
        width="90vw"
        bodyStyle={{ padding: 0, background: "#000", textAlign: "center" }}
      >
        <img
          alt="Preview"
          src={previewImage}
          style={{ maxWidth: "100%", maxHeight: "80vh", margin: "auto", display: "block" }}
        />
      </Modal>
    <Collapse style={{marginTop:"20px"}} defaultActiveKey={'2'} items={whats_new_items} activeKey={activeKey} 
            onChange={handleCollapseChange}

    />

      </div>
    ) 
}
export default WhatsNew;